import MaterialDivider, { DividerProps } from '@mui/material/Divider';

export function Divider(props: DividerProps) {
    return <MaterialDivider data-testid={'Divider-container'} {...props} />;
}

export default Divider;
